import React, { useEffect, useState } from "react"

import {
  Form,
  Input,
  Label,
  Row,
  Col,
  FormFeedback,
  ModalBody,
  Modal,
} from "reactstrap"

import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import OTPInput from "react-otp-input"
import {
  useGetOtpPhoneVerificationProfileMutation,
  useVerifyOtpPhoneVerificationProfileMutation,
} from "store/api/profile/profile.api"
import { useSelector } from "react-redux"
import closeIcon from "../../assets/images/icons/close.svg"
import { maskPhone, sanitizeIntegerInput } from "helpers/common"

const UpdatePhone = ({ open, setOpen }) => {
  const [sendOtp, { isLoading }] = useGetOtpPhoneVerificationProfileMutation()
  const [verifyOtp, { isLoading: isVerifying }] =
    useVerifyOtpPhoneVerificationProfileMutation()
  const [isOtp, setIsOtp] = useState(false)
  const counterTime = 60
  const [counter, setCounter] = useState(0)
  const { user } = useSelector((state) => state.user)

  useEffect(() => {
    validation.setFieldValue("phoneNumber", user?.phone || "")
  }, [user])

  const onSendOTP = async (body) => {
    try {
      const { success, message } = await sendOtp({
        phoneNumber: body["phoneNumber"].toString(),
        newPhoneNumber: body["newPhoneNumber"].toString(),
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        setIsOtp(true)
        setCounter(counterTime)
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const onVerifyOTP = async (body) => {
    try {
      const { success, message } = await verifyOtp({
        otp: body["otp"].toString(),
        newOtp: body["newOtp"].toString(),
        phoneNumber: body["phoneNumber"].toString(),
        newPhoneNumber: body["newPhoneNumber"].toString(),
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      phoneNumber: "",
      newPhoneNumber: "",
      otp: "",
      newOtp: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      if (!isOtp) {
        onSendOTP(values)
      } else {
        onVerifyOTP(values)
      }
    },
  })

  useEffect(() => {
    if (isOtp && counter > 0) {
      const timer = setTimeout(() => {
        setCounter(counter - 1)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [counter])

  const onResendOTP = () => {
    validation.setFieldValue("otp", "")
    validation.setFieldValue("newOtp", "")
    onSendOTP({ ...validation.values })
  }

  const toggle = () => setOpen(!open)

  return (
    <>
      <Modal size="md" isOpen={open} toggle={toggle} centered={true}>
        <div className="modal-content">
          <ModalBody>
            <Row>
              <Col xl={12}>
                <div className="platform-heading-section my-4 d-flex justify-content-between mt-0">
                  <div>
                    <h4>{!isOtp ? "Update Phone" : "Verify OTP"}</h4>
                    <p>
                      {!isOtp
                        ? "Please enter your current Phone no. and new Phone no."
                        : "Verify OTP sent to both Phone No."}
                    </p>
                  </div>
                  <div onClick={toggle}>
                    <img
                      className="cp"
                      src={closeIcon}
                      alt=""
                      height={"14px"}
                    />
                  </div>
                </div>
                <hr className="my-2" />
              </Col>
            </Row>
            <div className="">
              <Form
                onSubmit={(e) => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row className="mb-2">
                  {!isOtp ? (
                    <>
                      <Col xl={12}>
                        <Label className="col-form-label">Phone Number</Label>
                        <Input
                          name="phoneNumber"
                          type="number"
                          disabled
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Enter your phone number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phoneNumber}
                          invalid={
                            validation.touched.phoneNumber &&
                            validation.errors.phoneNumber
                          }
                        />
                        {validation.touched.phoneNumber &&
                        validation.errors.phoneNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.phoneNumber}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={12}>
                        <Label className="col-form-label">
                          New Phone Number
                        </Label>
                        <Input
                          name="newPhoneNumber"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="New phone number"
                          onChange={(e) =>
                            sanitizeIntegerInput(
                              e,
                              validation.setFieldValue,
                              "newPhoneNumber"
                            )
                          }
                          onBlur={validation.handleBlur}
                          value={validation.values.newPhoneNumber}
                          invalid={
                            validation.touched.newPhoneNumber &&
                            validation.errors.newPhoneNumber
                          }
                        />
                        {validation.touched.newPhoneNumber &&
                        validation.errors.newPhoneNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.newPhoneNumber}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <span className="floating-labels mt-1">
                        * We will send an OTP to both numbers via SMS
                      </span>
                    </>
                  ) : (
                    <Col xl={12}>
                      <div>
                        {/* <Label className="col-form-label">OTP</Label> */}
                        <div>
                          <Label className="form-label">
                            OTP(Sent on{" "}
                            {maskPhone(validation.values.phoneNumber)})
                          </Label>
                          <div
                            className={`${
                              validation.errors.otp && "is-invalid"
                            }`}
                          >
                            <OTPInput
                              onChange={(val) => {
                                validation.setFieldValue("otp", val)
                              }}
                              shouldAutoFocus
                              inputType={"number"}
                              inputStyle={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                border: "1px solid #ddd",
                              }}
                              containerStyle={{
                                display: "flex",
                                gap: "15px",
                              }}
                              value={validation.values.otp || ""}
                              numInputs={6}
                              renderInput={(props) => <input {...props} />}
                            />
                          </div>
                          {validation.errors.otp ? (
                            <FormFeedback type="invalid">
                              {validation.errors.otp}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mt-3">
                          <Label className="form-label">
                            OTP(Sent on{" "}
                            {maskPhone(validation.values.newPhoneNumber)})
                          </Label>
                          <div
                            className={`${
                              validation.errors.newOtp && "is-invalid"
                            }`}
                          >
                            <OTPInput
                              onChange={(val) => {
                                validation.setFieldValue("newOtp", val)
                              }}
                              inputType={"number"}
                              inputStyle={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                border: "1px solid #ddd",
                              }}
                              containerStyle={{
                                display: "flex",
                                gap: "15px",
                              }}
                              value={validation.values.newOtp || ""}
                              numInputs={6}
                              renderInput={(props) => <input {...props} />}
                            />
                          </div>
                          {validation.errors.newOtp ? (
                            <FormFeedback type="invalid">
                              {validation.errors.newOtp}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div
                          className="text-start mt-2"
                          style={{
                            color: "#a9a9a9",
                          }}
                        >
                          {counter > 0 && (
                            <p style={{ textAlign: "left" }}>
                              {`Didn't receive the OTP? Resend OTP in ${counter} sec`}
                            </p>
                          )}
                          {counter <= 0 && (
                            <div
                              style={{
                                color: "#035ca1",
                                cursor: "pointer",
                              }}
                              onClick={onResendOTP}
                              // cursor={"pointer"}
                              // color={Colors.text.black}
                            >
                              {isLoading ? (
                                <Spinners
                                  color="dark"
                                  className="align-items-center justify-content-start"
                                />
                              ) : (
                                "Resend OTP"
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  )}
                  <Col sm={12}>
                    <div className="d-flex flex-column align-items-center justify-content-center mt-3">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ minWidth: "200px" }}
                        disabled={isLoading || isVerifying}
                      >
                        {isLoading || isVerifying ? (
                          <Spinners />
                        ) : !isOtp ? (
                          "Get OTP"
                        ) : (
                          " Verify & Continue"
                        )}
                      </button>
                      {isOtp && (
                        <p
                          style={{
                            color: "#035ca1",
                            cursor: "pointer",
                            fontSize: "13px",
                            marginTop: "10px",
                          }}
                          onClick={() => setIsOtp(false)}
                        >
                          Change Number
                        </p>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  )
}

export default UpdatePhone
